// extracted by mini-css-extract-plugin
export default {"container":"container__WkGcy","head":"head__48FLn","title":"title__7hD-I","subtitle":"subtitle__98h28","alert":"alert__VlZaC","input":"input__XX2Yq"};